import useCreateDamageReportHook from "./use-create-damage-report-hook";


const DamageHooks = {
    useCreateDamageReport : useCreateDamageReportHook
}

export default DamageHooks;